<template>
  <main-layout>
    <h1 class="title">Crea preventivo</h1>
    <estimate-form :submit-action="create" redirect-route="estimates.show" />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import EstimateForm from "@/components/EstimateForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    EstimateForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    create: call("estimates/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
